import styled from 'styled-components';
import PropTypes from 'prop-types';

// SVG Images - Keep in alphabetical order
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as BalloonQuestion,
} from '../assets/svgImages/errorPage/balloonQuestion.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Banner529Image,
} from '../assets/svgImages/529_banner_image.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as BetaLight,
} from '../assets/svgImages/betaLight.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as BidenDebtRelief,
} from '../assets/svgImages/biden-debt-relief.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as BriefcaseAid,
} from '../assets/svgImages/briefcase-aid.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as BriefcasePlus,
} from '../assets/svgImages/briefcasePlus.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as BrowserChrome,
} from '../assets/svgImages/browser-chrome.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as BrowserFirefox,
} from '../assets/svgImages/browser-firefox.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as BrowserEdge,
} from '../assets/svgImages/browser-edge.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as CheckWatermark,
} from '../assets/svgImages/checkWatermark.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as ConsolidateLoans,
} from '../assets/svgImages/consolidateLoans.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as CreditCardCheck,
} from '../assets/svgImages/credit-card-check.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as ErrorImage,
} from '../assets/svgImages/errorPage/errorCloud.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as EmergencySavingsImage,
} from '../assets/svgImages/emergency-savings.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as FormDownloadIcon,
} from '../assets/svgImages/formDownloadIcon.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as LoansDocs,
} from '../assets/svgImages/loansDocs.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as LockNew,
} from '../assets/svgImages/lockNew.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as MoneyHand,
} from '../assets/svgImages/money-hand.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as MoreDetails,
} from '../assets/svgImages/moreDetails.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as RetirementMatch,
} from '../assets/svgImages/retirementMatch.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as RelinkSuccessImage,
} from '../assets/svgImages/relinkSuccessImage.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SummerBasicIdr,
} from '../assets/svgImages/summerBasicIdr.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SummerBasicPslf,
} from '../assets/svgImages/summerBasicPslf.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SummerBasicConsolidation,
} from '../assets/svgImages/summerBasicConsolidation.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as TuitionReimbursement,
} from '../assets/svgImages/tuitionReimbursement.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SavingsTargetDartThrow,
} from '../assets/svgImages/savings-target-dart-throw.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Student,
} from '../assets/svgImages/student.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Tracker,
} from '../assets/svgImages/tracker.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as WalletPainted,
} from '../assets/svgImages/wallet-painted.svg';

/**
 * No rest spread: props not listed here are dropped rather than forwarded.
 *
 * @typedef {Object} SvgImageProps
 * @property {React.ElementType} SvgComponent
 * @property {number} [width]
 * @property {number} [height]
 * @property {string} [className]
 * @property {React.MouseEventHandler<HTMLElement>} [onClick]
 * @property {React.CSSProperties} [style]
 */

/** @type {React.FC<SvgImageProps>} */
const SvgImage = ({
  // eslint-disable-next-line react/prop-types -- pre-existing; surfaced by reflow from a type-only change
  SvgComponent,
  width,
  height,
  className,
  onClick,
  style,
}) => {
  return (
    <StyledSvgImage
      svgWidth={width}
      svgHeight={height}
      className={className}
      onClick={onClick}
      style={style}
    >
      <SvgComponent />
    </StyledSvgImage>
  );
};

const StyledSvgImage = styled.div.attrs({
  className: 'icon',
})`
  display: flex;
  justify-content: center;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'auto')};

  & svg {
    width: ${({ svgWidth }) =>
      svgWidth ? `${svgWidth}px !important` : 'auto'};
    height: ${({ svgHeight }) =>
      svgHeight ? `${svgHeight}px !important` : 'auto'};
  }
`;

SvgImage.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default SvgImage;
